<template>
    <v-container fluid>
     <div class="text-h6 white--text" style="margin-top: 10px;">Área do Sócio</div>
     <v-row dense>
        <v-col cols="12">
          <v-card class="mx-auto card-button light-blue lighten-5" block :value="1" to="/socio/renovacao-taxas">
            <v-icon size="90" style="display: flex">mdi-sync</v-icon>
            <div class="text-center">Renovação das Taxas</div>
          </v-card>
        </v-col>
        <v-col cols="12" v-if="false">
          <v-card class="mx-auto card-button light-blue lighten-5" block :value="2" to="/socio/atualizacao-cadastral">
            <v-icon size="90" style="display: flex">mdi-account</v-icon>
            <div class="text-center">Atualização Cadastral</div>
          </v-card>
        </v-col>
        <v-col cols="12">
          <v-card class="mx-auto card-button light-blue lighten-5" block :value="3" to="/socio/extrato-financeiro">
            <v-icon size="90" style="display: flex">mdi-receipt</v-icon>
            <div class="text-center">Extrato Financeiro</div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
</template>
<style scoped>
.card-button {
  background-color: white;
  width: 100%;
  height: 150px !important;
}
</style>
<script>
export default {
  data: () => ({
    date: '2020-11-01'
  }),
  methods: {
  }
}
</script>
